import Button from "@/common/elements/Button";
import TextField from "@/common/elements/InputElements/TextField";
import Table from "@/common/elements/Table";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { Flex, Form, Popconfirm } from "antd";
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import PropertyModal from "./PropertyModal";
import {
  FormContainer,
  InmateDetailsTableContainer,
  TableHeader,
} from "./styles";
import Select from "@/common/elements/InputElements/Select";
import CommonDatePicker from "@/common/elements/DatePicker";
import dayjs from "dayjs";
import { labels } from "@/util/label";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import {
  debounce,
  getOptionsFromRefList,
  isNonEmptyVariable,
} from "@/util/common_function";
import { useDispatch, useSelector } from "react-redux";
import { setBookings, setDeleteAPis } from "@/slices/bookingsSlice";
import {
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  StopOutlined,
} from "@ant-design/icons";
import { v4 as uuidV4 } from "uuid";
import PropertyListQuickAddForm from "../BookingsDetails/PropertyListQuickAddForm";
import API_ENDPOINTS from "@/util/api"; // <-- Import API endpoints
import { hasCheckSecurity } from "@/util/common_function";
import {
  Entity_types,
  Permissions,
  Security_Types,
} from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import {
  MODULES_LIST_WITH_ID,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";
const PropertyTableHeaders = [
  { key: "inmatePropertyType", text: "Inmate Property Type" },
  { key: "location", text: "location" },
  { key: "Status", text: "Item Status" },
  { key: "color", text: "Item Color" },
  { key: "quantity", text: "Item Quantity" },
  { key: "description", text: "Summary Description" },
];

const Property = forwardRef(
  ({ propertyRef, propertyShow, isReleaseAllProperty }) => {
    const dispatch = useDispatch();
    const { bookings, bookingsFieldsEnabled } = useSelector(
      (state) => state?.bookings
    );
    const propertyItemFormRef = useRef();
    const propertyQuickAddFormRef = useRef();
    const [formOuter] = Form.useForm();

    const [isModalShown, setIsModalShown] = useState(false);
    const [inmateProperty, setInmateProperty] = useState(null);
    const [inmatePropertyItems, setInmatePropertyItems] = useState([]);
    const [propertyEditData, setPropertyEditData] = useState(null);
    const [isEdit, setisEdit] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const fullSearch = useSelector(state => state.fullSearch);
    const storageLocation1Options = getOptionsFromRefList(
      "Storage_Location_1",
      false,
      false,
      true
    );
    const storageLocation2Options = getOptionsFromRefList(
      "Inmate_Property_Storage_Location_1",
      false,
      false,
      true
    );
    const storageLocation3Options = getOptionsFromRefList(
      "Inmate_Property_Storage_Location_2",
      false,
      false,
      true
    );

    useEffect(() => {
      const inmatePropertyCopy = bookings?.inmateProperty?.[0];

      if (bookings !== null) {
        setInmateProperty(() => ({
          ...inmatePropertyCopy,
          dateTaken: inmatePropertyCopy?.dateTaken
            ? dayjs(inmatePropertyCopy?.dateTaken)
            : null,
          dateReleased: !fullSearch ? (inmatePropertyCopy?.dateReleased
            ? dayjs(inmatePropertyCopy?.dateReleased)
            : dayjs()) : null,
          propertyReleased: inmatePropertyCopy?.propertyReleased,
        }));

        setInmatePropertyItems(() => {
          return inmatePropertyCopy?.inmatePropertyItems?.map((i) => {
            const obj = {
              ...i,
              uuid: uuidV4(),
            };
            return obj;
          });
        });
      } else {
        setInmateProperty(null);
        setInmatePropertyItems([]);
      }
    }, [bookings]);

    useEffect(() => {
      if (inmateProperty !== null) {
        const values = {
          ...inmateProperty,
          takenBy: isNonEmptyVariable(inmateProperty?.takenBy)
            ? parseInt(inmateProperty.takenBy)
            : null,
        };
        formOuter.setFieldsValue(values);
      } else {
        formOuter.resetFields();
      }
    }, [inmateProperty]);

    // Expose form methods to parent
    useImperativeHandle(propertyRef, () => ({
      submitForm: () => formOuter.submit(),
      resetForm: () => formOuter.resetFields(),
      getFormValues: () => formOuter.getFieldsValue(),
      getFieldsError: () => formOuter.getFieldsError(),
      isFieldsValidating: () => formOuter.isFieldsValidating(),
      validateFields: () => formOuter.validateFields(),
    }));

    const handleSubmit = () => {
      propertyItemFormRef?.current
        ?.validateFields()
        .then(() => {
          const formValues = propertyItemFormRef.current.getFormValues();
          console.log("Form values on submit:", formValues);

          const { imagePath } = formValues;

          console.log("imagePath", imagePath, formValues);

          // updateForm(inmatePropertyItems, "table");

          let data = isNonEmptyVariable(inmatePropertyItems)
            ? JSON.parse(JSON.stringify(inmatePropertyItems))
            : [];

          if (isNonEmptyVariable(propertyEditData) && data?.length) {
            data = data?.map((p) => {
              if (p?.uuid === propertyEditData.uuid) {
                return {
                  ...p,
                  ...formValues,
                };
              }
              return p;
            });
          } else {
            data.push({ ...formValues });
          }

          updateForm(data, "table");

          setBookings((prevBookings) => [
            ...prevBookings,

            {
              ownerAppliedNumber:
                inmateProperty?.propertyExtras?.[0]?.ownerAppliedNumber,
              propertyExtraId:
                inmateProperty?.propertyExtras?.[0]?.propertyExtraId,
              ...formValues,
            },
          ]);

          onCancelClick();
        })
        .catch((err) => {
          console.error("Validation error:", err);
        });
    };

    const onAddClick = () => {
      setPropertyEditData(() => null);
      const form = propertyItemFormRef?.current?.form;
      setIsModalShown(true);
      form?.resetFields();
      if (form?.getFieldsValue())
        Object.keys(form.getFieldsValue())?.forEach((k) => {
          form.setFieldValue(k, "");
        });
    };

    const onCancelClick = () => {
      setPropertyEditData(() => null);
      setIsModalShown(false);
      setisEdit(false);
    };

    const onTableRowSelected = (values) => {
      const data = inmatePropertyItems?.find((ip) => ip?.uuid === values?.uuid);
      setPropertyEditData(() => ({
        ...data,
        ownerAppliedNumber:
          inmateProperty?.propertyExtras?.[0]?.ownerAppliedNumber,
        propertyExtraId: inmateProperty?.propertyExtras?.[0]?.propertyExtraId,
      }));
    };

    const onPropertyEditClick = () => {
      setIsModalShown(true);
      setisEdit(true);
    };

    const onPropertyDeleteClick = () => {
      // Create a copy and filter out the deleted property item.
      let data = JSON.parse(JSON.stringify(inmatePropertyItems));
      data = data?.filter((d) => d?.uuid !== propertyEditData?.uuid);

      if (propertyEditData?.inmatePropertyItemId) {
        const url =
          API_ENDPOINTS.inmateProperty + propertyEditData?.inmatePropertyItemId;
        dispatch(setDeleteAPis(url));
      }

      // Update the bookings with the new filtered data.
      dispatch(
        setBookings({
          inmateProperty: [
            {
              ...bookings?.inmateProperty?.[0],
              inmatePropertyItems: data,
            },
          ],
        })
      );

      onCancelClick();
    };

    const updateForm = (data, key = "") => {
      console.log(data);
      if (key === "table") {
        dispatch(
          setBookings({
            inmateProperty: [
              {
                ...inmateProperty,
                propertyComments: inmateProperty?.propertyComments,
                propertyExtras: [
                  {
                    ownerAppliedNumber:
                      data.find(
                        (p) =>
                          p?.ownerAppliedNumber !== null &&
                          p?.ownerAppliedNumber !== undefined
                      )?.ownerAppliedNumber || "",
                    propertyId: inmateProperty?.inmatePropertyId,
                    propertyExtraId: inmateProperty?.propertyExtras?.find(
                      (propExtra) =>
                        propExtra.propertyId ===
                        inmateProperty?.inmatePropertyId
                    )?.propertyExtraId,
                  },
                ],
                dateTaken: isNonEmptyVariable(inmateProperty?.dateTaken)
                  ? dayjs(inmateProperty?.dateTaken)?.format("MM/DD/YYYY")
                  : null,
                dateReleased: !fullSearch ? (isNonEmptyVariable(inmateProperty?.dateReleased)
                  ? dayjs(inmateProperty?.dateReleased)?.format("MM/DD/YYYY")
                  : dayjs()) : null,
                propertyReleased:
                  inmateProperty?.itemStatus !== "Disposed" ? false : true,
                inmatePropertyItems: data,
              },
            ],
          })
        );
      } else {
        const updatedBookings = {
          inmateProperty: [
            {
              ...inmateProperty,
              ...data,
              propertyExtras: [
                {
                  ownerAppliedNumber: data?.ownerAppliedNumber || "",
                  propertyId: inmateProperty?.inmatePropertyId,
                  propertyExtraId: inmateProperty?.propertyExtras?.find(
                    (propExtra) => {
                      propExtra.propertyId === inmateProperty?.inmatePropertyId;
                    }
                  )?.inmatePropertyId,
                },
              ],
              propertyComments: data?.propertyComments,
              dateTaken: isNonEmptyVariable(data?.dateTaken)
                ? dayjs(data?.dateTaken)?.format("MM/DD/YYYY")
                : null,
              propertyReleased: inmateProperty?.propertyReleased,
              dateReleased: !fullSearch ? (isNonEmptyVariable(data?.dateReleased)
                ? dayjs(data?.dateReleased)?.format("MM/DD/YYYY")
                : dayjs()) : null,
              propertyPhotos: data[0]?.propertyPhotos
                ? [
                    ...(bookings?.inmateProperty?.[0]?.propertyPhotos || []),
                    data[0].propertyPhotos,
                  ]
                : [],
            },
          ],
        };

        console.log("Updated bookings object:", updatedBookings);
        dispatch(setBookings(updatedBookings));
      }
    };

    const dataModify = debounce(() => {
      const values = formOuter.getFieldsValue();
      const data = {
        ...values,
        dateTaken: isNonEmptyVariable(values?.dateTaken)
          ? dayjs(values?.dateTaken)?.format("MM/DD/YYYY")
          : null,
        dateReleased: !fullSearch ? (isNonEmptyVariable(values?.dateReleased)
          ? dayjs(values?.dateReleased)?.format("MM/DD/YYYY")
          : dayjs()) : null,
        propertyComments:
          values?.propertyComments || inmateProperty?.propertyComments,
      };

      updateForm(data);
    }, 800);

    const handleQuickAdd = () => {
      if (!propertyQuickAddFormRef.current) return;

      propertyQuickAddFormRef.current
        .validateFields()
        .then((values) => {
          if (!isNonEmptyVariable(values)) return;

          // Assume in the quick add form:
          // - storageLocation2Id represents Loc. 1,
          // - storageLocation3Id represents Loc. 2,
          // and we set a default for storageLocation1Id.
          const defaultLoc = 50500006;
          const loc2Value = values?.inventoryItems?.[0]?.storageLocation2Id || "";
          const loc3Value = values?.inventoryItems?.[0]?.storageLocation3Id || "";

          // Retrieve the location options from the reference list.
          const storageLocation1Options = getOptionsFromRefList("Storage_Location_1", false, false, true);
          const storageLocation2Options = getOptionsFromRefList(
            "Inmate_Property_Storage_Location_1",
            false,
            false,
            true
          );
          const storageLocation3Options = getOptionsFromRefList(
            "Inmate_Property_Storage_Location_2",
            false,
            false,
            true
          );

          // Lookup the label for each location value.
          const loc1Name =
            storageLocation1Options.find((opt) => opt.value === defaultLoc)
              ?.label || defaultLoc;
          const loc2Name =
            storageLocation2Options.find((opt) => opt.value === loc2Value)
              ?.label || loc2Value;
          const loc3Name =
            storageLocation3Options.find((opt) => opt.value === loc3Value)
              ?.label || loc3Value;

          // Build the custody comment using the location names.
          const locationComment = `ORIGINAL STORAGE: ${loc1Name}:${loc2Name}:${loc3Name}`;

          // Create the initial custody transaction for check in.
          const initialCustody = {
            inventoryItemTransactionId: null,
            dateAdded: !fullSearch ? dayjs().format("MM/DD/YYYY") : null,
            timeAdded: !fullSearch ? dayjs().format("HH:mm") : null,
            user: "System",
            transactionType: "Initial Entry",
            comments: fullSearch ? ((loc1Name || loc2Name || loc3Name) ? locationComment : null) : locationComment,
            inventoryItemTransactionsExtras: [],
          };

          // Create the new property item including the custody transaction and item status.
          const newPropertyItem = {
            ...values,
            uuid: uuidV4(),
            inventoryItemTransactions: [initialCustody],
            // Set the itemStatus to "Checked In" by default.
            itemStatus: "Checked In",
          };

          setInmatePropertyItems((prevItems = []) => {
            if (isNonEmptyVariable(newPropertyItem.inmatePropertyType)) {
              const updatedItems = [...prevItems, newPropertyItem];
              updateForm(updatedItems, "table");
              return updatedItems;
            } else {
              return prevItems;
            }
          });

          // Reset the quick add form after adding the item.
          propertyQuickAddFormRef.current.resetForm();
        })
        .catch((err) => {
          console.error("Validation failed:", err);
        });
    };

    return (
      <>
        {propertyShow && (
          <FormContainer>
            <Form
              form={formOuter}
              initialValues={inmateProperty}
              disabled={!bookingsFieldsEnabled}
              onFieldsChange={() => {
                dataModify();
              }}
            >
              <StyledGridRow gutter={[16]}>
                <StyledGridCol span={8}>
                  <FormItem
                    name="searchOfficerStaffId"
                    label={labels.searchedBy}
                  >
                    <Select
                      showSearch={true}
                      options={getOptionsFromRefList("", true, false, true)}
                      disabled={!bookingsFieldsEnabled}
                    />
                  </FormItem>
                </StyledGridCol>

                <StyledGridCol span={8}>
                  <FormItem
                    name="searchTechniqueId"
                    label={labels.searchTechnique}
                  >
                    <Select
                      options={getOptionsFromRefList(
                        "Search_Technique",
                        false,
                        false,
                        true
                      )}
                      disabled={!bookingsFieldsEnabled}
                      showSearch={true}
                    />
                  </FormItem>
                </StyledGridCol>

                <StyledGridCol span={8}>
                  <FormItem name="takenBy" label={labels.takenBy}>
                    <Select
                      showSearch={true}
                      options={getOptionsFromRefList("", true)}
                      disabled={!bookingsFieldsEnabled}
                    />
                  </FormItem>
                </StyledGridCol>

                <StyledGridCol span={8}>
                  <FormItem name="releasedTo" label={labels.releasedTo}>
                    <TextField />
                  </FormItem>
                </StyledGridCol>

                <StyledGridCol span={8}>
                  <FormItem name="dateTaken" label={labels.propertyDate}>
                    <CommonDatePicker
                      format="MM/DD/YYYY"
                      placeholder="MM/DD/YYYY"
                      showTime={false}
                      disabled={!bookingsFieldsEnabled}
                    />
                  </FormItem>
                </StyledGridCol>

                <StyledGridCol span={8}>
                  <FormItem name="cash" label={labels.cash}>
                    <TextField
                      onKeyDown={(e) => {
                        if (
                          e.key.match(/[^0-9.]/) &&
                          e.key !== "Backspace" &&
                          e.key !== "Tab" &&
                          e.key !== "ArrowLeft" &&
                          e.key !== "ArrowRight"
                        ) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </FormItem>
                </StyledGridCol>
              </StyledGridRow>

              {(isReleaseAllProperty || inmateProperty?.propertyReleased) && (
                <StyledGridRow gutter={[16]}>
                  <StyledGridCol span={8}>
                    <FormItem
                      name="releasedTo"
                      label="Actually Released To"
                      rules={[
                        {
                          required: true,
                          message: "Please enter Actually Released To",
                        },
                      ]}
                    >
                      <TextField />
                    </FormItem>
                  </StyledGridCol>
                  <StyledGridCol span={8}>
                    <FormItem
                      name="releasedByStaffId"
                      label="Released By"
                      rules={[
                        { required: true, message: "Please enter Released By" },
                      ]}
                    >
                      <Select
                        showSearch={true}
                        options={getOptionsFromRefList("", true)}
                        disabled={!bookingsFieldsEnabled}
                      />
                    </FormItem>
                  </StyledGridCol>
                  <StyledGridCol span={8}>
                    <FormItem
                      name="dateReleased"
                      label="Release Date"
                      rules={[
                        {
                          required: true,
                          message: "Please select Release Date",
                        },
                      ]}
                      initialValue={dayjs()}
                    >
                      <CommonDatePicker
                        format="MM/DD/YYYY"
                        placeholder="MM/DD/YYYY"
                        showTime={false}
                        disabled={!bookingsFieldsEnabled}
                      />
                    </FormItem>
                  </StyledGridCol>
                </StyledGridRow>
              )}
            </Form>
          </FormContainer>
        )}

        {!propertyShow && (
          <>
            <PropertyListQuickAddForm
              bookingsFieldsEnabled={bookingsFieldsEnabled}
              ref={propertyQuickAddFormRef}
              onQuickAdd={handleQuickAdd}
            />

            <InmateDetailsTableContainer>
              <TableHeader>
                <h6>List of items taken</h6>
                <Flex gap={4}>
                  <Button
                    color="primary"
                    type="primary"
                    className="add-btn"
                    onClick={onAddClick}
                    icon={<PlusOutlined />}
                    disabled={
                      !bookingsFieldsEnabled ||
                      !hasCheckSecurity(
                        Security_Types.functionality,
                        Entity_types.subModule,
                        LABELS_CAPITAL.ADD,
                        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                        SUB_MODULES_LIST_WITH_ID.Inmate_Property
                      )
                    }
                  >
                    Add
                  </Button>

                  <Button
                    color="primary"
                    type="primary"
                    className="add-btn"
                    onClick={onPropertyEditClick}
                    icon={<EditOutlined />}
                    disabled={
                      propertyEditData === null ||
                      !hasCheckSecurity(
                        Security_Types.functionality,
                        Entity_types.subModule,
                        LABELS_CAPITAL.VIEW,
                        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                        SUB_MODULES_LIST_WITH_ID.Inmate_Property
                      )
                    }
                  >
                    Details
                  </Button>

                  <Popconfirm
                    title="Delete the property item"
                    description="Are you sure to delete this property item?"
                    onConfirm={onPropertyDeleteClick}
                    onCancel={() => {}}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button
                      color="primary"
                      type="primary"
                      className="add-btn"
                      icon={<DeleteOutlined />}
                      disabled={
                        !bookingsFieldsEnabled ||
                        propertyEditData === null ||
                        !hasCheckSecurity(
                          Security_Types.functionality,
                          Entity_types.subModule,
                          LABELS_CAPITAL.DELETE,
                          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                          SUB_MODULES_LIST_WITH_ID.Inmate_Property
                        )
                      }
                    >
                      Delete
                    </Button>
                  </Popconfirm>

                  <Button
                    color="primary"
                    type="primary"
                    className="add-btn"
                    onClick={onCancelClick}
                    icon={<StopOutlined />}
                    disabled={ propertyEditData === null }
                  >
                    Cancel
                  </Button>
                </Flex>
              </TableHeader>

              {hasCheckSecurity(
                Security_Types.functionality,
                Entity_types.subModule,
                LABELS_CAPITAL.VIEW,
                MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                SUB_MODULES_LIST_WITH_ID.Inmate_Property
              ) && (
                <Table
                  headers={PropertyTableHeaders}
                  data={
                    inmatePropertyItems?.map((i) => {
                      const loc1Id = i?.inventoryItems?.[0]?.storageLocation1Id;
                      const loc2Id = i?.inventoryItems?.[0]?.storageLocation2Id;
                      const loc3Id = i?.inventoryItems?.[0]?.storageLocation3Id;

                      const loc1Name =
                        storageLocation1Options.find(
                          (opt) => opt.value === loc1Id
                        )?.label || "";
                      const loc2Name =
                        storageLocation2Options.find(
                          (opt) => opt.value === loc2Id
                        )?.label || "";
                      const loc3Name =
                        storageLocation3Options.find(
                          (opt) => opt.value === loc3Id
                        )?.label || "";

                      return {
                        inmatePropertyId: i?.inmatePropertyId,
                        inmatePropertyType: isNonEmptyVariable(
                          i?.inmatePropertyType
                        )
                          ? i?.inmatePropertyType
                          : "",
                        uuid: i?.uuid,
                        location: `${loc1Name} : ${loc2Name} : ${loc3Name}`,
                        Status: isNonEmptyVariable(
                          i?.inventoryItems?.[0]?.itemStatus
                        )
                          ? i?.inventoryItems?.[0]?.itemStatus
                          : "Checked In",
                        color: isNonEmptyVariable(
                          i?.inventoryItems?.[0]?.propertyCommon?.[0]?.color
                        )
                          ? i?.inventoryItems?.[0]?.propertyCommon?.[0]?.color
                          : "",
                        quantity: isNonEmptyVariable(
                          i?.inventoryItems?.[0]?.propertyCommon?.[0]?.quantity
                        )
                          ? i?.inventoryItems?.[0]?.propertyCommon?.[0]
                              ?.quantity
                          : "",
                        description: `${
                          isNonEmptyVariable(
                            i?.inventoryItems?.[0]?.propertyCommon?.[0]
                              ?.description
                          )
                            ? i?.inventoryItems?.[0]?.propertyCommon?.[0]
                                ?.description
                            : ""
                        } ${
                          isNonEmptyVariable(
                            i?.inventoryItems?.[0].propertyWithSerialNumber?.[0]
                              ?.propertyWithSerialNumberId
                          )
                            ? i?.inventoryItems?.[0]
                                .propertyWithSerialNumber?.[0]
                                ?.propertyWithSerialNumberId
                            : ""
                        }`,
                      };
                    }) || []
                  }
                  onRowClick={onTableRowSelected}
                  onRowDoubleClick={(data) => {
                    onTableRowSelected(data);
                    onPropertyEditClick();
                  }}
                  selected={propertyEditData === null}
                />
              )}

              <StyledGridCol lg={24}>
                <Form
                  form={formOuter}
                  onFieldsChange={() => {
                    dataModify();
                  }}
                >
                  <FormItem label="Comments" name="propertyComments">
                    <TextField inputType="textarea" rows="4" disabled={!bookingsFieldsEnabled} />
                  </FormItem>
                </Form>
              </StyledGridCol>
            </InmateDetailsTableContainer>
            {isModalShown && (
              <PropertyModal
                show={isModalShown}
                propertyItemFormRef={propertyItemFormRef}
                property={propertyEditData}
                handleCancel={onCancelClick}
                handleSubmit={handleSubmit}
                isEdit={isEdit}
              />
            )}
          </>
        )}
      </>
    );
  }
);

export default Property;
